import Tooltip from 'antd/lib/tooltip'
import { Divider, NotificationBadge, SidebarItem } from 'Core/Workbench'
import classes from './Sidebar.module.less'
import { sendAnalyticsTrack } from 'Utils/analytics.utils.ts'
import { ContainerType, TaskConfigType } from 'Types/Tasks.types'
import Badge from 'antd/lib/badge'

export type SidebarProps = {
    sidebarItems: (SidebarItem | Divider)[]
    notificationBadges: NotificationBadge[]
    activeItem?: string
    toggleItem: (item: string) => void
    placement: 'left' | 'right'
    taskConfig: TaskConfigType<ContainerType, unknown>
}

export const isDivider = (item: SidebarItem | Divider): item is Divider => {
    return 'isDivider' in item && item.isDivider
}

// TODO: CRF Move to /layout
export const Sidebar: React.FC<SidebarProps> = (props: SidebarProps) => {
    const handleSidebarItemClick = (item: SidebarItem, isActive: boolean) => {
        const analyticsObject = {
            project_id: props.taskConfig.assignment.project_id,
            user_id: props.taskConfig.assignment.user_id,
            task_id: props.taskConfig.assignment.task.id,
            step_id: props.taskConfig.assignment.step?.id,
        }

        isActive
            ? sendAnalyticsTrack(item.title.replace(/\s/g, '') + '_Closed', analyticsObject)
            : sendAnalyticsTrack(item.title.replace(/\s/g, '') + '_Opened', analyticsObject)

        props.toggleItem(item.id)
    }

    return (
        <div
            className={classes.sidebarItemsContainer}
            data-testid={`sidebar-wrapper-${props.placement}`}
        >
            {props.sidebarItems.map((item, i) => {
                if (isDivider(item)) {
                    return (
                        <div key={`divider-${item.isDivider}-${i}`} className={classes.divider} />
                    )
                }
                const isActive = item.id === props.activeItem
                const Icon = item.icon
                const showNotificationBadge: boolean = !!props.notificationBadges.find(
                    notificationItem => notificationItem.id === item.id
                )
                return (
                    <Tooltip
                        key={item.id}
                        title={item.title}
                        placement={props.placement === 'right' ? 'left' : 'right'}
                    >
                        <div
                            className={classes.sidebarItem + (isActive ? ` ${classes.active}` : '')}
                        >
                            <Badge
                                color="red"
                                dot={showNotificationBadge}
                                className={item.isElementHighlighted ? ` ${classes.highlight}` : ''}
                            >
                                <button
                                    className={classes.sidebarIconContainer}
                                    onClick={() => {
                                        handleSidebarItemClick(item, isActive)
                                    }}
                                    data-testid="sidebar-button"
                                >
                                    <Icon color={isActive ? '#4B286D' : '#B2B9BF'} />
                                </button>
                            </Badge>
                        </div>
                    </Tooltip>
                )
            })}
        </div>
    )
}
